var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5427 13.8557C47.3974 13.575 47.1464 13.3637 46.8454 13.2687C46.5443 13.1733 46.2177 13.2019 45.9373 13.3477C45.6573 13.4939 45.4469 13.7452 45.352 14.0469C45.2576 14.3486 45.2865 14.675 45.4326 14.9553C47.6652 19.2205 48.4743 24.0892 47.7409 28.8485C47.0075 33.6075 44.7706 38.006 41.3578 41.3994C32.5444 50.2185 18.2043 50.2202 9.38808 41.3994H9.3885C9.04802 41.0586 8.53625 40.9565 8.0917 41.1409C7.6471 41.3254 7.357 41.7599 7.35742 42.2413V48.2638C7.35742 48.9218 7.89018 49.4545 8.54718 49.4545C9.20421 49.4545 9.73693 48.9217 9.73693 48.2638V44.9074C14.5414 48.7542 20.5931 50.6945 26.7364 50.358C32.8797 50.0214 38.6834 47.4314 43.0404 43.0834C50.7926 35.3247 52.6024 23.5795 47.5431 13.8555L47.5427 13.8557Z",
    fill: "url(#paint0_linear_148_228)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3903 9.40346C12.196 6.59502 15.6911 4.57514 19.5236 3.54702C23.3567 2.51926 27.3925 2.51926 31.2256 3.54702C35.0586 4.5752 38.5537 6.59502 41.3594 9.40346C41.6995 9.74423 42.2116 9.84633 42.6562 9.66187C43.1008 9.47783 43.3905 9.04336 43.3905 8.56147V2.53905C43.3905 1.88147 42.8577 1.34829 42.2007 1.34829C41.5437 1.34829 41.0109 1.8815 41.0109 2.53905V5.89339C36.5381 2.30423 30.9683 0.362987 25.2346 0.395795C19.5018 0.428149 13.9539 2.43288 9.52271 6.07324C5.09106 9.71328 2.04476 14.768 0.894882 20.3892C-0.255431 26.0104 0.560696 31.8569 3.20604 36.9469C3.50915 37.5301 4.22748 37.7566 4.81022 37.4532C5.39294 37.1494 5.61922 36.4305 5.31611 35.8472C3.08309 31.5824 2.27358 26.7134 3.0071 21.954C3.74012 17.1955 5.97698 12.7966 9.39019 9.40317L9.3903 9.40346Z",
    fill: "url(#paint1_linear_148_228)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3739 7.06384C22.878 7.06636 20.4855 8.06009 18.7209 9.82614C16.9564 11.5922 15.9635 13.9868 15.961 16.4847V21.2004H14.5239C13.4512 21.2012 12.4231 21.6281 11.6645 22.3874C10.9063 23.1462 10.4798 24.1752 10.4785 25.2489V36.8327C10.4798 37.9058 10.9063 38.9353 11.6645 39.6941C12.4231 40.4534 13.4513 40.8803 14.5239 40.8811H36.2243C37.297 40.8803 38.3252 40.4534 39.0834 39.6941C39.842 38.9353 40.2685 37.9059 40.2698 36.8327V25.2489C40.2686 24.1753 39.842 23.1463 39.0834 22.3874C38.3252 21.6281 37.297 21.2013 36.2243 21.2004H34.7873V16.4847C34.7843 13.9867 33.7919 11.5922 32.0269 9.82571C30.2619 8.05969 27.8693 7.06642 25.3735 7.06384H25.3739ZM18.3401 16.4847C18.3401 13.9695 19.6811 11.6455 21.8575 10.3879C24.0339 9.13019 26.7149 9.1303 28.8913 10.3879C31.0676 11.6454 32.4082 13.9695 32.4082 16.4847V21.2004H18.3407L18.3401 16.4847ZM37.89 25.2489L37.8904 36.8327C37.8896 37.2747 37.7141 37.6982 37.4017 38.0108C37.0894 38.3234 36.6662 38.4991 36.2245 38.4995H14.5241C14.0825 38.4991 13.6593 38.3235 13.3469 38.0108C13.0346 37.6982 12.8591 37.2747 12.8583 36.8327V25.2489C12.8591 24.8068 13.0346 24.3833 13.3469 24.0707C13.6593 23.7581 14.0825 23.5824 14.5241 23.5816H36.2245C36.6662 23.5824 37.0894 23.7581 37.4017 24.0707C37.7141 24.3833 37.8896 24.8069 37.8904 25.2489H37.89Z",
    fill: "url(#paint2_linear_148_228)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3667 31.0404C35.3667 32.3559 34.3011 33.422 32.987 33.422C31.6729 33.422 30.6074 32.356 30.6074 31.0404C30.6074 29.7252 31.6729 28.6592 32.987 28.6592C34.3011 28.6592 35.3667 29.7252 35.3667 31.0404Z",
    fill: "url(#paint3_linear_148_228)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7553 31.0404C27.7553 32.3559 26.6898 33.422 25.3757 33.422C24.0616 33.422 22.9961 32.356 22.9961 31.0404C22.9961 29.7252 24.0616 28.6592 25.3757 28.6592C26.6898 28.6592 27.7553 29.7252 27.7553 31.0404Z",
    fill: "url(#paint4_linear_148_228)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1401 31.0404C20.1401 32.3559 19.0746 33.422 17.7605 33.422C16.4461 33.422 15.3809 32.356 15.3809 31.0404C15.3809 29.7252 16.446 28.6592 17.7605 28.6592C19.0746 28.6592 20.1401 29.7252 20.1401 31.0404Z",
    fill: "url(#paint5_linear_148_228)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_148_228",
    x1: 28.8717,
    y1: 13.2133,
    x2: 28.8717,
    y2: 50.3954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#362960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F508C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_148_228",
    x1: 21.8886,
    y1: 0.395386,
    x2: 21.8886,
    y2: 37.5878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#362960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F508C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_148_228",
    x1: 25.3742,
    y1: 7.06384,
    x2: 25.3742,
    y2: 40.8811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#362960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F508C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_148_228",
    x1: 32.987,
    y1: 28.6592,
    x2: 32.987,
    y2: 33.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#362960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F508C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_148_228",
    x1: 25.3757,
    y1: 28.6592,
    x2: 25.3757,
    y2: 33.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#362960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F508C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_148_228",
    x1: 17.7605,
    y1: 28.6592,
    x2: 17.7605,
    y2: 33.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#362960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F508C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPassword);
export default __webpack_public_path__ + "static/media/resetPassword.2d11c87b79c7b11d0db3f126804d38e9.svg";
export { ForwardRef as ReactComponent };